import { axiosAjax } from '@app/src/config/axios';
import { hydrateData } from './hydrators';
import { VignetteModel } from '@app/src/views/StepTwo/channelPublication/models/vignette';
import { isClientEnv } from '@app/src/utils/validations';

export const vignetteService = {
  async get( categoryId: number, publicationId?: number ): Promise<VignetteModel[]> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(
        process.env.API_VIGNETTE
          .replace(':categoryId', '' + categoryId)
          .replace(':publicationId', '' + publicationId),
          config
      );
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
}
